import { useTexture } from "@react-three/drei";
import React, { FC } from "react";
import { useStore } from "../../../store";
import { FULL } from "../utils";

export const FullNarrativeFrame: FC = () => {
  const url = useStore((s) => s.assetUrl);
  const texture = useTexture(url("/assets/textures/ui/c_narrative_full.svg"));

  return (
    <mesh>
      <boxGeometry args={FULL.toArray()} />
      <meshPhongMaterial map={texture} transparent={true} />
    </mesh>
  );
};
